import "./Banner.css";
import BannerImage from "../../assets/Banner/SVG/banner-illustration.svg";
const Banner = () => {
  return (
    <section class="banner-section">
      <div class="container">
        <div class="banner-wrapper row">
          <div class="col-12 col-sm-6 col-md-6 col-lg-6 banner-text-div">
            <h1>The Orchestration Engine for Governing Intelligent Systems</h1>
            <p>
              AI is autonomous and decision-making. AgentGRC.ai goes beyond
              monitoring to orchestrate trust, compliance, and control across
              the AI lifecycle — built for what traditional GRC can’t govern.
            </p>
            <div class="banner-button">
              <a href="https://demo.akira.ai/agentgrc/">
                <button>
                  <p>Book Demo Now</p>
                </button>
              </a>
            </div>
          </div>
          <div class="col-12 col-sm-6 col-md-6 col-lg-6 banner-image">
            <img src={BannerImage} alt="banner-image" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Banner;
